import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

export const styles = (breakpoint: number) => {
  let OverrideBars: BoxProps = {}
  let overrideHeader: ViewStyle = {}
  if (breakpoint < 850) {
    OverrideBars = {
      display: 'flex',
      backgroundColor: 'WHITE',
      justifyContent: 'center',
      alignContent: 'center',
      padding: 8,
      marginVertical: 8,
      // Todo
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      shadowColor: '#0000001F' as ColorOptions,
      borderRadius: 4,
      zIndex: 4,
    } as BoxProps
    overrideHeader = {
      justifyContent: 'space-between',
      width: '100%',
    } as ViewStyle
  }

  return {
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginHorizontal: 16,
      minHeight: '5vh',
      zIndex: 50,
    } as ViewStyle,
    buttonBox: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      minWidth: 100,
    } as BoxProps,
    buttonOverlayStyle: {
      backgroundColor: 'TRANSPARENT',
      width: '100%',
      height: '100%',
      position: 'absolute',
      zIndex: 200,
      margin: 0,
      padding: 0,
    } as BoxProps,
    menuContainer: () =>
      ({
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        flex: 1,
        alignSelf: 'stretch',
        justifyContent: 'space-between',
        flexWrap: 'wrap-reverse',
        marginRight: 8,
        ...overrideHeader,
      } as BoxProps),
    searchContainer: {
      flexDirection: 'row',
      backgroundColor: 'WHITE',
      alignItems: 'center',
      marginVertical: 8,
      ml: 5,
      // Todo
      borderRadius: 4,
    } as BoxProps,
    topContainer: { flexDirection: 'row', marginTop: 16 } as ViewStyle,
    separator: {
      width: 2,
      height: '60%',
      // Todo
      backgroundColor: '#CCCCCC',
      opacity: 0.6,
      alignSelf: 'center',
      justifyContent: 'center',
    } as ViewStyle,
    merchantBox: {
      display: 'flex',
      height: 34,
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
      backgroundColor: 'WHITE',
      padding: 5,
      paddingHorizontal: 10,
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      // Todo
      shadowColor: '#0000001F' as ColorOptions,
      borderRadius: 4,
      zIndex: 4,
      // marginHorizontal: 12,
    } as BoxProps,
    merchantTitle: {
      fontSize: 12,
      // Todo
      color: '#555555',
      fontWeight: '600',
    } as ViewStyle,
    countStyle: {
      fontSize: 'FONT_SIZE_TINY',
      fontWeight: '600',
      color: 'WHITE',
      textAlign: 'center',
    } as TextProps,
    notificationContainer: {
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      // Todo
      shadowColor: '#0000001F' as ColorOptions,
      borderRadius: 4,
      zIndex: 4,
      padding: 7,
      backgroundColor: 'WHITE',
      display: 'none',
    } as BoxProps,
    viewAllContainer: {
      width: 320,
      textAlign: 'center',
      alignContent: 'center',
      justifyContent: 'center',
      height: 40,
      fontSize: 14,
    } as ViewStyle,
    viewAllText: {
      // Todo
      color: 'BLUE',
      fontSize: 14,
      textAlign: 'center',
    } as TextProps,
    notificationlistContainer: {
      shadowOffset: { width: 1, height: 1 },
      shadowRadius: 3,
      shadowColor: '#0000001F' as ColorOptions,
      borderRadius: 8,
      borderWidth: 1,
      borderColor: '#00000014' as ColorOptions,
      zIndex: 10,
      backgroundColor: 'WHITE',
      alignItems: 'center',
      marginTop: 54,
      marginRight: 20,
    } as BoxProps,
    modesBox: {
      flexDirection: 'column',
      width: 120,
      height: 30,
      display: 'none',
    } as BoxProps,
    searchViewContainer: { flexDirection: 'row', marginTop: 16, marginLeft: 4 } as BoxProps,
    bars: {
      display: 'none',
      marginRight: 16,
      ...OverrideBars,
    } as ViewStyle,
    gradientBgStyle: {
      width: 220,
      height: '100vh',
    } as ViewStyle,
  }
}

export const stylesHeader = (breakpoint: number) => {
  let OverrideBars: ViewStyle = {}
  if (breakpoint < 850) {
    OverrideBars = {
      display: 'flex',
      // Todo
      backgroundColor: '#FFFFFF',
      justifyContent: 'center',
      alignContent: 'center',
      paddingHorizontal: 8,
      shadowOffset: { width: 0, height: 2 },
      shadowRadius: 3,
      // Todo
      shadowColor: '#0000001F',
      borderRadius: 4,
      zIndex: 4,
    } as ViewStyle
  }
  return {
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 8,
      // minHeight: '5vh',
      zIndex: 50,
      flexWrap: 'wrap-reverse',
      paddingBottom: 8,
    } as BoxProps,
    bars: {
      display: 'none',
      marginRight: 16,
      ...OverrideBars,
    } as ViewStyle,
    gradientBgStyle: {
      width: 220,
      height: '100vh',
    } as ViewStyle,
  }
}
